<template>
  <div class="not-found">
    <h1>404<span>Not Found</span></h1>
    <p class="mt-10">お探しのページは見つかりませんでした</p>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found {
  margin-top: 60px;
  text-align: center;
}

.not-found h1 {
  font-size: 84px;
  letter-spacing: 10px;
  line-height: 1;
}

.not-found h1 span {
  display: inline-block;
  margin-left: 16px;
  font-size: 38px;
  color: #444;
  letter-spacing: 4px;
}

.not-found p {
  font-size: 24px;
}
</style>
